import {
  Box,
  Button as CButton,
  Checkbox,
  CircularProgress,
  Container,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  HStack,
  Image,
  InputGroup,
  InputLeftElement,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import Google from "assets/icons/google.svg";
import { ReactComponent as Logo } from "assets/logos/s-logo.svg";
import Button from "components/Button/Button";
import Input from "components/Input/Input";
import PasswordInput from "components/Input/PasswordInput";
import { OptionLabel, RSelect } from "components/Select/RSelect";
// import RSelect from "react-select";
import Select from "components/Select/Select";
import constant from "config/constant";
import useCountries from "hooks/useCountries";
import useInputCheck from "hooks/useInputCheck";
import { debounce, toLower } from "lodash";
import capitalize from "lodash/capitalize";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import GoogleLogin from "react-google-login";
import Recaptcha from "react-google-recaptcha";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useGetCookieByPassQuery, useSignUpMutation, useSignUpViaSocialMutation } from "services/arbitraryApi";
import { hydrateToken } from "store/slices/auth.slice";
import { getCookie } from "util/utils";

import isPhoneValid, { cleanPhone } from "util/validatePhone";

const Signup = () => {
  const toast = useToast();
  const history = useHistory();
  const dispatch = useDispatch();
  const recaptchaInstanceRef = useRef();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { data, status, detectedCountry } = useCountries();

  console.log(detectedCountry.CountryName);

  console.log("refCode", params.get("refCode"));

  let refCode = params.get("refCode");

  if (!refCode) {
    const BTM_REF = getCookie("BTM_REF");
    if (BTM_REF) {
      try {
        const decodedRef = JSON.parse(decodeURIComponent(BTM_REF));
        if (decodedRef && decodedRef.refCode) {
          refCode = decodedRef.refCode;
          console.log("refCode from cookies ", refCode);
          const url = new URL(window.location.href);
          url.searchParams.set("refCode", String(refCode || ""));
          if (decodedRef?.refsite || document.referrer)
            url.searchParams.set("refsite", String(decodedRef?.refsite || document.referrer || ""));
          window.history.replaceState(null, null, url);
        }
      } catch (err) {
        console.log({ err });
      }
    }
  }

  const initialState = refCode ? { refCode, acceptPromotions: true } : { acceptPromotions: true };

  const [formData, setFormData] = useState(initialState);

  const [phone, setPhone] = useState({ code: {}, number: "" });
  // const [country, setCountry] = useState("");

  const cleanUpPhoneNumber = useCallback(
    (number) => cleanPhone(phone?.codeValue ?? detectedCountry.CountryCode, number),
    [phone?.codeValue, detectedCountry]
  );

  // console.log("Striped Number", cleanUpPhoneNumber(phone?.number), phone);

  const countryIsLoading = useMemo(() => status === "fetching", [status]);

  useGetCookieByPassQuery();

  const [signUp, { data: signUpResult, isLoading: isSigningUp, isSuccess, isError, error }] = useSignUpMutation();

  const [
    signInViaSocial,
    {
      data: socialSignInResult,
      isLoading: isSigningInViaSocial,
      isSuccess: isSocialSuccess,
      isError: isSocialError,
      error: socialError,
    },
  ] = useSignUpViaSocialMutation();

  const { makeCheck, check: inputCheck } = useInputCheck();

  const passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

  const usernamePattern = /^[a-z0-9]+([._]?[a-z0-9]+)*$/;

  const isPasswordValid = useCallback(
    () => formData?.password && RegExp(passwordPattern).test(formData?.password),
    // eslint-disable-next-line
    [formData?.password]
  );

  const isUsernameValid = useCallback(
    () => formData?.username && RegExp(usernamePattern).test(formData?.username),
    // eslint-disable-next-line
    [formData?.username]
  );

  const isCheckingEmail = useCallback((type) => inputCheck(type).status === "fetching", [inputCheck]);

  const isAlreadyInUse = useCallback((type) => inputCheck(type).inUse, [inputCheck]);

  const phoneCodeOptions = () =>
    status === "success" &&
    data.data.countries.map((country) => ({
      label: <OptionLabel rtl label={`${country?.countryCode ?? ""}`} img={country.flag ?? ""} />,
      value: `${country?.countryCode ?? ""}`,
    }));

  const handleFormData = (data) => {
    setFormData({ ...formData, ...data });
    if (data?.email) {
      debounce(() => makeCheck("email", data?.email), 1000)();
    }

    if (data?.username) {
      debounce(() => makeCheck("username", data?.username), 1000)();
    }

    // if (data?.phoneNumber && phone?.code?.value) {
    //   debounce(() => makeCheck("phone", data?.username), 1000)();
    // }
  };

  const handlePhone = (input) => {
    setPhone({ ...phone, ...input });
    const countryInfo = data.data.countries.find((c) => c.countryCode === input?.codeValue);

    // console.log("CODE VALUE", input?.codeValue);

    // console.log("COUNTRY", input.codeValue, countryInfo);

    input?.code && handleFormData({ country: countryInfo?.country });
  };

  // console.log("form data", formData);

  // const [countryValue, setCountryValue]
  const handleCountry = (e) => {
    console.log(e.target.value, "target");

    handleFormData({ country: e.target.value });

    setFormData({ ...formData, country: "nigeria" });

    const countryInfo = data.data.countries.find((c) => toLower(c?.country) === toLower(e.target.value));

    // console.log("countryInfo", countryInfo);

    handlePhone({
      code: {
        label: <OptionLabel rtl label={`${countryInfo?.countryCode ?? ""}`} img={countryInfo?.flag ?? ""} />,
        value: `${countryInfo?.countryCode ?? ""}`,
      },
      codeValue: `${countryInfo?.countryCode ?? ""}`,
    });
  };

  // useEffect(() => {
  //   if (data && detectedCountry) {
  //     handleCountry({ target: { value: detectedCountry?.CountryName } });
  //   }
  // }, [detectedCountry]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData, "form data");
    const signupData = {
      ...formData,
      phone: `${phone?.code?.value}${phone?.number}`,
      qrRef: params.get("qrRef"),
    };
    // console.log("FORM DATA", signupData);

    if (navigator.onLine === true) {
      const captch = await recaptchaInstanceRef.current?.executeAsync();
      // recaptchaInstanceRef.current?.reset();
      console.log(captch, "captch");

      signUp({ ...signupData, humanKey: captch });
    }
  };

  const googleSignIn = async (res) => {
    const googleId = {
      idToken: res.tokenId,
    };
    signInViaSocial(googleId);
  };

  const googleSignInFailed = (res) => console.log("GOOGLE SIGNIN FAILURE", res);

  // console.log("COUNTRIES", detectedCountry);
  // console.log("SIGNUP DATA", signUpResult);

  const getError = (error) => {
    function isObj(obj) {
      var type = typeof obj;
      return type === "function" || (type === "object" && !!obj);
    }
    const value = isObj(error) ? Object.values(error)[0] : error;
    // console.log("ERROR VALUE", value);
    return value ?? "An unexpected error occurred";
  };

  // useEffect(() => {
  //   const refCode = params.get("refCode");
  //   if (refCode) handleFormData({ refCode });
  // });

  useEffect(() => {
    if (isSuccess && signUpResult) {
      console.log("SIGNUP RESPONSEdddddddd", signUpResult);
      recaptchaInstanceRef.current?.reset();
      dispatch(
        hydrateToken({
          token: signUpResult.token,
          isSignedIn: false,
        })
      );

      // history.replace(constant.PAGES.VERIFY_EMAIL_PASSWORD);
      window.location = constant.PAGES.VERIFY_EMAIL_PASSWORD;
    }

    if (isError && error) {
      // getError(error?.data?.error);
      // console.log(error);
      recaptchaInstanceRef.current?.reset();
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, signUpResult, isError, error, toast, history, dispatch]);

  useEffect(() => {
    if (isSocialSuccess && socialSignInResult) {
      // recaptchaInstanceRef.current?.reset();

      console.log("GOOGLE SIGIN IN DATA", socialSignInResult);
      dispatch(hydrateToken({ token: socialSignInResult.token }));
      if (socialSignInResult.twoFactor !== false) {
        history.replace(constant.PAGES.VERIFY_TWO_FA);
      } else {
        history.replace(constant.PAGES.HOME);
      }
    }

    if (isSocialError && socialError) {
      console.log(socialError?.data);
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description: getError(socialError?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });

      dispatch(
        hydrateToken({
          token: socialError?.data?.data?.token,
          isSignedIn: false,
        })
      );
      if (socialError?.data?.data?.errorCode === "EA-006-NO_AUTH") {
        // history.push("/confirmnumber");
        history.push(constant.PAGES.VERIFY_EMAIL_PASSWORD);
      }
      if (socialError?.data?.data?.errorCode === "EA-005-NO_AUTH") {
        // history.push("/verifyemail");
        history.push(constant.PAGES.VERIFY_EMAIL_PASSWORD);
      }
    }
  }, [isSocialSuccess, socialSignInResult, isSocialError, socialError, toast, history, dispatch]);

  const isDisabled = useMemo(
    () =>
      !(
        formData?.firstName &&
        formData?.lastName &&
        formData?.email &&
        formData?.username &&
        formData?.password &&
        phone?.code?.value &&
        phone?.number &&
        formData?.country
      ) ||
      !isPasswordValid() ||
      !isUsernameValid() ||
      isSigningUp,
    [formData, phone, isPasswordValid, isSigningUp, isUsernameValid]
  );

  console.log("Country", formData?.country);

  const isPhoneNumberValid = useMemo(
    () => isPhoneValid(String(formData?.country ?? detectedCountry.CountryName).toLowerCase(), phone?.number),
    [phone?.number, formData?.country, detectedCountry.CountryName]
  );

  // console.log(
  //   "Is phone valid",
  //   isPhoneNumberValid,
  //   String(formData?.country ?? detectedCountry.CountryName).toLowerCase(),
  //   phone?.number
  // );

  return (
    <Box py={["10px", "20px"]}>
      <Container maxW="container.sm">
        <Box bg="#fcfcfc" p={["10px", "16px", "28px"]}>
          <VStack>
            <Box w={["100px", "initial"]} as={Logo} />
            <Heading as="h3" fontSize={["24px", "32px"]}>
              Welcome
            </Heading>
            <Text textAlign="center" fontSize={["32px", "44px"]}>
              Let's get you started
            </Text>
            <Text textAlign="center" fontSize={["sm", "md"]}>
              Fill in your details to create your account
            </Text>
          </VStack>

          <Box as="form" mt="66px" px={[0, "8px", "12px"]} onSubmit={handleSubmit}>
            <HStack flexDir={["column", "row"]}>
              <FormControl>
                <FormLabel
                  fontWeight="normal"
                  fontSize="sm"
                  // htmlFor="firstName"
                >
                  Firstname
                </FormLabel>
                <Input
                  value={formData?.firstName ?? ""}
                  onChange={(e) => handleFormData({ firstName: e.target.value })}
                  isRequired
                  // name="firstName"
                  placeholder="First name"
                />
              </FormControl>

              <FormControl mt={["20px !important", "0 !important"]} ml={["0 !important", "10px !important"]}>
                <FormLabel
                  fontWeight="normal"
                  fontSize="sm"
                  // htmlFor="lastName"
                >
                  Lastname
                </FormLabel>
                <Input
                  value={formData?.lastName ?? ""}
                  onChange={(e) => handleFormData({ lastName: e.target.value })}
                  isRequired
                  // name="lastName"
                  placeholder="Last name"
                />
              </FormControl>
            </HStack>

            <HStack mt="20px" flexDir={["column", "row"]} alignItems="flex-start">
              <FormControl>
                <FormLabel
                  fontWeight="normal"
                  fontSize="sm"
                  // htmlFor="email"
                >
                  Email
                </FormLabel>
                <Input
                  isInvalid={!isCheckingEmail("email") && formData?.email && isAlreadyInUse("email")}
                  value={formData?.email ?? ""}
                  isRequired
                  // name="email"
                  type="email"
                  placeholder="Email"
                  onChange={(e) => handleFormData({ email: e.target.value })}
                />
                <HStack mt="8px">
                  {isCheckingEmail("email") && <CircularProgress isIndeterminate color="green" size="14px" />}
                  {formData?.email &&
                    !isCheckingEmail("email") &&
                    // formData?.email &&
                    isAlreadyInUse("email") && (
                      <FormHelperText fontSize="xs" m="0" color="red.400">
                        Email is already registered
                      </FormHelperText>
                    )}
                </HStack>
              </FormControl>

              <FormControl mt={["20px !important", "0 !important"]} ml={["0 !important", "10px !important"]}>
                <FormLabel
                  fontWeight="normal"
                  fontSize="sm"
                  // htmlFor="userName"
                >
                  Username
                </FormLabel>
                <Input
                  isInvalid={(formData?.username && !isUsernameValid()) || isAlreadyInUse("username")}
                  pattern="^[a-z0-9]+([._]?[a-z0-9]+)*$"
                  value={formData?.username ?? ""}
                  onChange={(e) => handleFormData({ username: e.target.value })}
                  isRequired
                  name="userName"
                  placeholder="Username"
                />

                <HStack mt="8px">
                  {isCheckingEmail("username") && <CircularProgress isIndeterminate color="green" size="14px" />}
                  {formData?.username && !isUsernameValid() && (
                    <FormHelperText fontSize="xs" m="0" color="red.400">
                      Username should be an alphanumeric in lowercase can have _ and . in between characters
                    </FormHelperText>
                  )}

                  {formData?.username && isUsernameValid() && isAlreadyInUse("username") && (
                    <FormHelperText fontSize="xs" m="0" color="red.400">
                      Username is taken
                    </FormHelperText>
                  )}
                </HStack>
              </FormControl>
            </HStack>

            <FormControl mt="20px">
              <FormLabel
                fontWeight="normal"
                fontSize="sm"
                // htmlFor="password"
              >
                Password
              </FormLabel>

              <PasswordInput
                value={formData?.password ?? ""}
                onChange={(e) => handleFormData({ password: e.target.value })}
                isRequired
                pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
                isInvalid={formData?.password && !isPasswordValid()}
                // name="password"
                placeholder="Password"
              />

              {formData?.password && !isPasswordValid() && (
                <FormHelperText fontSize="xs" color="red.400">
                  Password must have at least one uppercase letter, and number and a special character
                </FormHelperText>
              )}
            </FormControl>

            <FormControl mt="20px">
              <FormLabel
                fontWeight="normal"
                fontSize="sm"
                // htmlFor="password"
              >
                Referral Code (optional)
              </FormLabel>

              <Input
                value={formData?.refCode ?? ""}
                onChange={(e) => handleFormData({ refCode: e.target.value })}
                // name="referral"
                placeholder="Referral Code - Optional"
              />
            </FormControl>

            <FormControl mt="20px">
              <FormLabel
                fontWeight="normal"
                fontSize="sm"
                // htmlFor="password"
              >
                Phone number
              </FormLabel>

              <InputGroup w="100%">
                <InputLeftElement
                  // left="42px"
                  w={["120px", "150px"]}
                  h="54px"
                  children={
                    <RSelect
                      container={{
                        height: "49px",
                      }}
                      control={{ height: "50px" }}
                      defaultInputValue={detectedCountry.CountryCode}
                      placeholder="select"
                      autoComplete={false}
                      isLoading={countryIsLoading}
                      value={phone?.code ?? ""}
                      onChange={(e) => handlePhone({ code: e, codeValue: e?.value })}
                      options={phoneCodeOptions()}
                    />
                  }
                />
                <Input
                  isInvalid={
                    (!isCheckingEmail("phone") && formData?.phone && isAlreadyInUse("phone")) ||
                    !isPhoneNumberValid?.valid
                  }
                  value={phone?.number ?? ""}
                  onChange={(e) => handlePhone({ number: cleanUpPhoneNumber(e.target.value) })}
                  isRequired
                  max={14}
                  // type="tel"
                  pl={["126px", "154px"]}
                  w="100%"
                  placeholder="Phone number"
                  // name="phoneNumber"
                />
              </InputGroup>

              <HStack mt="12px">
                {isCheckingEmail("phone") && <CircularProgress isIndeterminate color="green" size="14px" />}
                {!isCheckingEmail("phone") &&
                  // formData?.email &&
                  isAlreadyInUse("phone") && (
                    <FormHelperText m="0" color="red.400">
                      Phone number already in use
                    </FormHelperText>
                  )}

                {!isPhoneNumberValid && (
                  <FormHelperText m="0" color="red.400">
                    {isPhoneNumberValid?.message}
                  </FormHelperText>
                )}
              </HStack>
            </FormControl>

            <FormControl mt="20px">
              <FormLabel
                fontWeight="normal"
                fontSize="sm"
                // htmlFor="password"
              >
                Country
              </FormLabel>

              <Select
                value={formData?.country}
                onChange={(e) => {
                  handleCountry(e);
                  handleFormData({ country: e.target.value });
                }}
                // defaultInputValue="Nigeria"
              >
                {status === "success" &&
                  data.data.countries.map((country) => (
                    <option
                      defaultValue={"nigeria"}
                      defaultChecked={true}
                      key={country.country}
                      value={country.country}
                    >
                      {capitalize(country.country)}
                    </option>
                  ))}
              </Select>
            </FormControl>

            <FormControl>
              <Checkbox
                isChecked={formData.acceptPromotions ?? false}
                size="md"
                fontSize={["sm", "initial"]}
                colorScheme="green"
                mt="20px"
                className="newsletterCheckbox"
                __css={{
                  ".chakra-checkbox__control:focus, .chakra-checkbox__control[data-focus]": {
                    boxShadow: "0 0 0 3px #06C3448f",
                  },
                }}
                onChange={() =>
                  handleFormData({
                    acceptPromotions: !formData?.acceptPromotions,
                  })
                }
              >
                I want to receive Bitmama newsletters
              </Checkbox>
            </FormControl>

            <Button disabled={isDisabled} isLoading={isSigningUp} type="submit" mt="2em" w="100%" minH="56px">
              Create Account
            </Button>

            <Recaptcha ref={recaptchaInstanceRef} sitekey={process.env.REACT_APP_RECAPTCHA} size={"invisible"} />

            <VStack mt="10px">
              <Text my="14px" fontWeight="400" fontSize="sm" textTransform="uppercase">
                Or
              </Text>
              <GoogleLogin
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                onSuccess={googleSignIn}
                onFailure={googleSignInFailed}
                render={(renderProps) => (
                  <CButton
                    isLoading={isSigningInViaSocial}
                    onClick={renderProps.onClick}
                    disabled={renderProps.disabled || isSigningInViaSocial}
                    _focus={{
                      borderColor: "#06C344",
                      boxShadow: "0 0 0 3px #06C3448f",
                    }}
                    border="1px solid #dadada"
                    h="56px"
                    borderRadius="16px"
                    px="12px"
                  >
                    <HStack>
                      <Image src={Google} alt="google" />
                      <Text fontWeight="400">Sign up with google</Text>
                    </HStack>
                  </CButton>
                )}
                // onSuccess={this.successGoogle}
                // onFailure={this.failureGoogle}
                cookiePolicy={"single_host_origin"}
              />

              <HStack my="14px !important">
                <Text>Have an account? </Text>
                <CButton
                  _focus={{ boxShadow: "0 0 0 3px #06C3448f" }}
                  variant="link"
                  color="#06C344"
                  onClick={() => history.push("/")}
                >
                  Sign in
                </CButton>
              </HStack>
            </VStack>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Signup;
